import { useTranslation } from 'react-i18next'

import type { CommentTab } from '#/shared/ui/comment-tool'
import {
  CheckRoundedIcon,
  ContractIcon,
  EditIcon,
  EmailIcon,
  FileIcon,
  PaymentIcon,
  PhoneChatIcon,
} from '#/shared/ui/icons'

import { SHIPMENT_COMMENT_TAB } from '../comment-panel-tabs'

/** Which tabs show a notification dot (the shipment already has such an item). */
export interface TabBadges {
  note?: boolean
  task?: boolean
  file?: boolean
}

export function useTabs(badges: TabBadges = {}): CommentTab[] {
  const { t } = useTranslation()
  return [
    {
      value: SHIPMENT_COMMENT_TAB.note,
      label: t('orderDetails.comment.tabs.note'),
      icon: EditIcon,
      badge: badges.note,
    },
    {
      value: SHIPMENT_COMMENT_TAB.task,
      label: t('orderDetails.comment.tabs.task'),
      icon: CheckRoundedIcon,
      badge: badges.task,
    },
    {
      value: SHIPMENT_COMMENT_TAB.phone,
      label: t('orderDetails.comment.tabs.phone'),
      icon: PhoneChatIcon,
    },
    {
      value: SHIPMENT_COMMENT_TAB.email,
      label: t('orderDetails.comment.tabs.email'),
      icon: EmailIcon,
    },
    {
      value: SHIPMENT_COMMENT_TAB.file,
      label: t('orderDetails.comment.tabs.file'),
      icon: FileIcon,
      badge: badges.file,
    },
    {
      value: SHIPMENT_COMMENT_TAB.contract,
      label: t('orderDetails.comment.tabs.contract'),
      icon: ContractIcon,
    },
    {
      value: SHIPMENT_COMMENT_TAB.payment,
      label: t('orderDetails.comment.tabs.payment'),
      icon: PaymentIcon,
    },
  ]
}
